import Base from 'app/views/base';

import { displayErrorsOnView, displayErrorOnField, clearPopoversOnView } from 'utils/forms';
import { showSuccess, getResponseErrors } from 'utils/messages';

import tmpl from 'templates/user_edit_info';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #user_edit_info': 'submit',
  },

  initialize() {
    this.listenTo(this.model, 'change', this.render);
  },

  beforeRender() {
    clearPopoversOnView(this);
  },

  context() {
    return {
      phone_number: this.model.get('phone_number'),
      name: this.model.get('name'),
    };
  },

  submit(e) {
    e.preventDefault();

    const self = this;
    this.model.update({
      name: this.$('#user_name').val(),
      phone_number: this.$('#user_phone_number').val(),
    }, {
      success() {
        self.render();
        showSuccess('Profile successfully updated');
      },
      error(model, response) {
        self.render();
        const errors = getResponseErrors(response);
        displayErrorsOnView(self, errors, ['name', 'phone_number']);
      },
    });
  },

  setFocus(attribute) {
    this.$(`#user_${attribute}`).focus();
  },

  displayError(attribute, message) {
    const formField = this.$(`#user_${attribute}`);
    displayErrorOnField(formField, message);
  },
});



// WEBPACK FOOTER //
// ./app/views/user_edit_info_view.js